import React from 'react';

const Logo = (props) => {
  var companylogo = "/static/" + localStorage.getItem('companylogo');
  var logowidth = localStorage.getItem('companylogowidth');
  var logoheight = localStorage.getItem('companylogohigth');
  return (
    <img
      alt="Logo"
      src={companylogo}
      width={(logowidth > 1) ? logowidth : "100%"}
      height={(logoheight > 1) ? logoheight : "100%"}
      {...props}
    />
  );
};

export default Logo;
